var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.button)?_c('a',{staticClass:"button",class:_vm.getClass,attrs:{"href":"#","ref_testcafe":_vm.testcafeRef},on:{"click":function($event){$event.preventDefault();return _vm.handleError.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm._f("parseTicketError")(_vm.getFullError,true))+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }